import { render, staticRenderFns } from "./Favoritevideo.vue?vue&type=template&id=5c60e1f4"
import script from "./Favoritevideo.vue?vue&type=script&lang=js"
export * from "./Favoritevideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports